var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventIconDemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.43 229.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#176c4a;}.cls-5{fill:url(#linear-gradient);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:#219777;}.cls-19,.cls-8,.cls-9{fill:#fff;}.cls-8{opacity:0.5;}.cls-10{fill:#fb876d;}.cls-11{fill:#fdf281;}.cls-12{fill:#00f7c6;}.cls-13{fill:url(#radial-gradient);}.cls-14,.cls-16,.cls-17{mix-blend-mode:multiply;}.cls-14{fill:url(#radial-gradient-2);}.cls-15{fill:url(#radial-gradient-3);}.cls-16{fill:url(#radial-gradient-4);}.cls-17{fill:url(#radial-gradient-5);}.cls-18,.cls-22{mix-blend-mode:screen;}.cls-18{fill:url(#radial-gradient-6);}.cls-19{opacity:0.5;}.cls-20{fill:url(#radial-gradient-7);}.cls-21{fill:url(#linear-gradient-2);}.cls-22{fill:url(#radial-gradient-8);}.cls-23{fill:url(#linear-gradient-3);}.cls-24{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.8 192.18 111.14 132.48 191.24 171.55 98.9 231.25 18.8 192.18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 133.93,
    x2: 186.2,
    y2: 133.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce35b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cde25d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#a8de60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#89db63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#71d966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#60d768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#56d669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53d669"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.49 143.86 68.56 116.01 138.09 149.92 95.02 177.77 25.49 143.86"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 943.31,
    cy: 2.97,
    r: 48.49,
    gradientTransform: "translate(-773.23 252.56) rotate(-11.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb2e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 931.23,
    cy: -1.91,
    r: 28.62,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 966.74,
    cy: 13.22,
    r: 43.73,
    gradientTransform: "translate(-773.23 252.56) rotate(-11.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#375ecb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375ecb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 964.12,
    cy: -8.19,
    r: 43.73,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 965.4,
    cy: -24.85,
    r: 23.38,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 939.59,
    cy: -60.07,
    r: 27.75,
    gradientTransform: "matrix(-0.9, 0.43, -0.15, -0.32, 977.12, -408.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#033b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 894.13,
    cy: -50.72,
    r: 57.4,
    gradientTransform: "translate(-773.23 252.56) rotate(-11.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#033b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033b1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4243.85,
    y1: 1412.94,
    x2: 4238.33,
    y2: 1394.06,
    gradientTransform: "translate(-3371.77 2780.26) rotate(-56.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#387397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#387699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3980a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3b91ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3ca9bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#3fc7d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ebef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 880.97,
    cy: -69.15,
    r: 34.51,
    gradientTransform: "matrix(0.62, -0.79, 0.36, 0.28, -439.82, 728.8)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 4286.33,
    y1: 1414.97,
    x2: 4187.6,
    y2: 1340.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 4220.98,
    y1: 1341.84,
    x2: 4151.29,
    y2: 1272.43,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Microsoft Excel - Basic &amp;amp; Advanced") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.69,132.75a15.13,15.13,0,0,0-3.5,1.63L25.8,187.65c-3.85,2.5-4.38,5.81-1.18,7.37l68.45,33.39c3.21,1.56,9,.8,12.84-1.69l63-40.72,3.7-23.1-60.9-30.15"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.2,106.35,121.6,74.84c-3.95-1.93-11.08-1-15.84,2.09L4.05,142.69c-4.76,3.08-5.42,7.18-1.47,9.1L87.1,193c4,1.93,11.08,1,15.84-2.08l77.74-50.26,5.52-34.32"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.46,124.74l-15.34-7.48c-1.41-.69-3.94-.36-5.63.74s-1.93,2.55-.52,3.24l15.33,7.48c1.42.69,3.94.35,5.64-.75s1.93-2.54.52-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111,136.71l-15.33-7.48c-1.41-.69-3.94-.36-5.63.74s-1.93,2.55-.52,3.24l15.33,7.48c1.42.69,3.94.35,5.63-.75s1.94-2.54.52-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M135.53,148.68,120.2,141.2c-1.41-.69-3.94-.36-5.63.74s-1.94,2.55-.52,3.23l15.33,7.48c1.42.69,3.94.36,5.63-.74s1.94-2.54.52-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M74.15,132.7l-15.34-7.48c-1.41-.69-3.93-.36-5.63.74s-1.92,2.54-.51,3.23L68,136.67c1.42.69,3.93.36,5.63-.74s1.93-2.54.52-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M98.69,144.66l-15.34-7.47c-1.41-.69-3.93-.36-5.63.74s-1.93,2.54-.52,3.23l15.34,7.48c1.42.69,3.93.36,5.63-.74s1.93-2.54.52-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M123.23,156.63l-15.34-7.48a6.49,6.49,0,0,0-5.63.75c-1.7,1.09-1.93,2.54-.52,3.23l15.34,7.48c1.41.69,3.93.36,5.63-.74s1.93-2.55.52-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61.85,140.65l-15.34-7.48c-1.41-.69-3.93-.35-5.63.74s-1.93,2.55-.52,3.24l15.33,7.48c1.42.69,3.94.35,5.64-.74s1.93-2.55.52-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.39,152.62l-15.34-7.48c-1.41-.69-3.94-.36-5.63.74s-1.93,2.55-.52,3.24l15.33,7.48c1.42.69,3.94.35,5.64-.75s1.93-2.54.52-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M110.92,164.59l-15.33-7.48c-1.41-.69-3.94-.36-5.63.74s-1.93,2.55-.52,3.24l15.33,7.48c1.42.69,3.94.35,5.63-.75s1.94-2.54.52-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M49.54,148.61,34.2,141.13c-1.41-.69-3.93-.36-5.63.74s-1.93,2.55-.52,3.24l15.33,7.48c1.42.69,3.94.35,5.64-.75s1.93-2.54.52-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M74.08,160.58,58.74,153.1c-1.41-.69-3.93-.36-5.63.74s-1.93,2.55-.52,3.24l15.33,7.47c1.42.7,3.94.36,5.64-.74s1.93-2.54.52-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.62,172.54l-15.34-7.48c-1.41-.68-3.93-.35-5.63.75s-1.93,2.55-.52,3.23l15.33,7.48c1.42.69,3.94.36,5.64-.74s1.93-2.55.52-3.24"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.2,106.35l-25.26,20c-5,4-5.71,8.2-1.55,9.38l21,5.94,5.82-35.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M186.43,106.57l-24.2,10.48c-4.6,2-5.56,5.84-1.47,9.1l19.91,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.4,94.55,131,91.91l-10.71,3.48c-1.13.37-2.27.75-3.43,1.15l-3.79,1.33-.18-.09c.59-.87,1.13-1.67,1.64-2.38s1-1.41,1.45-2.11l4.51-6.5L114.81,84l-9.12,14.57-26,7.54,5.41,2.64,11.57-3.6,3.76-1.25,4-1.38.18.09-1.73,2.49c-.53.76-1.07,1.53-1.6,2.31l-4.63,7,5.67,2.77,9.38-15.35,24.69-7.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "124.9 21.98 132.52 28.11 130.86 37.31 123.25 31.18 124.9 21.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "132.52 28.11 140.14 34.23 138.48 43.43 130.86 37.31 132.52 28.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "140.14 34.23 147.75 40.35 146.1 49.55 138.48 43.43 140.14 34.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "123.25 31.18 130.86 37.31 129.21 46.51 121.59 40.38 123.25 31.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "130.86 37.31 138.48 43.43 136.82 52.63 129.21 46.51 130.86 37.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "138.48 43.43 146.1 49.55 144.44 58.75 136.82 52.63 138.48 43.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "121.59 40.38 129.21 46.51 127.55 55.71 119.93 49.59 121.59 40.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "129.21 46.51 136.82 52.63 135.17 61.83 127.55 55.71 129.21 46.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "136.82 52.63 144.44 58.75 142.78 67.95 135.17 61.83 136.82 52.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "140.14 34.23 132.52 28.11 124.9 21.98 123.25 31.18 121.59 40.38 119.93 49.59 127.55 55.71 135.17 61.83 142.78 67.95 144.44 58.75 146.1 49.55 147.75 40.35 140.14 34.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "140.14 34.23 132.52 28.11 124.9 21.98 123.25 31.18 121.59 40.38 119.93 49.59 127.55 55.71 135.17 61.83 142.78 67.95 144.44 58.75 146.1 49.55 147.75 40.35 140.14 34.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "175.28 31.06 166.01 34.14 164.35 43.34 173.63 40.26 175.28 31.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "166.01 34.14 156.73 37.22 155.08 46.42 164.35 43.34 166.01 34.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "156.73 37.22 147.46 40.3 145.8 49.5 155.08 46.42 156.73 37.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "173.63 40.26 164.35 43.34 162.7 52.54 171.97 49.46 173.63 40.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "164.35 43.34 155.08 46.42 153.42 55.62 162.7 52.54 164.35 43.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "155.08 46.42 145.8 49.5 144.15 58.7 153.42 55.62 155.08 46.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "171.97 49.46 162.7 52.54 161.04 61.74 170.31 58.66 171.97 49.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "162.7 52.54 153.42 55.62 151.76 64.82 161.04 61.74 162.7 52.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "153.42 55.62 144.15 58.7 142.49 67.9 151.76 64.82 153.42 55.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "166.01 34.14 156.73 37.22 147.46 40.3 145.8 49.5 144.15 58.7 142.49 67.9 151.76 64.82 161.04 61.74 170.31 58.66 171.97 49.46 173.63 40.26 175.28 31.06 166.01 34.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "166.01 34.14 156.73 37.22 147.46 40.3 145.8 49.5 144.15 58.7 142.49 67.9 151.76 64.82 161.04 61.74 170.31 58.66 171.97 49.46 173.63 40.26 175.28 31.06 166.01 34.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "158.53 28.07 167.81 25 175.42 31.12 166.15 34.2 158.53 28.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "124.75 21.99 134.02 18.91 141.64 25.03 132.37 28.11 124.75 21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "134.02 18.91 143.3 15.83 150.91 21.95 141.64 25.03 134.02 18.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "143.3 15.83 152.57 12.75 160.19 18.88 150.91 21.95 143.3 15.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "132.37 28.11 141.64 25.03 149.26 31.15 139.98 34.23 132.37 28.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "141.64 25.03 150.91 21.95 158.53 28.07 149.26 31.15 141.64 25.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "150.91 21.95 160.19 18.88 167.81 25 158.53 28.07 150.91 21.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "139.98 34.23 149.26 31.15 156.88 37.27 147.6 40.35 139.98 34.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "149.26 31.15 158.53 28.07 166.15 34.2 156.88 37.27 149.26 31.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "158.53 28.07 167.81 25 175.42 31.12 166.15 34.2 158.53 28.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "167.81 25 160.19 18.88 152.57 12.75 143.3 15.83 134.02 18.91 124.75 21.99 132.37 28.11 139.98 34.23 147.6 40.35 156.88 37.27 166.15 34.2 175.42 31.12 167.81 25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "167.81 25 160.19 18.88 152.57 12.75 143.3 15.83 134.02 18.91 124.75 21.99 132.37 28.11 139.98 34.23 147.6 40.35 156.88 37.27 166.15 34.2 175.42 31.12 167.81 25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M175.63,30.89,168,24.77l-7.62-6.12-7.62-6.12a.34.34,0,0,0-.31-.06l-9.27,3.08-9.28,3.08-9.27,3.08a.28.28,0,0,0-.2.23.28.28,0,0,0,.1.27l-1.61,8.92-1.65,9.2-1.66,9.2a.29.29,0,0,0,.11.28l7.62,6.12L135,62.06l7.22,5.79a.28.28,0,0,0,.11.27.26.26,0,0,0,.15.07.26.26,0,0,0,.15,0,.37.37,0,0,0,.14.07.33.33,0,0,0,.17,0,.27.27,0,0,0,.19-.21l8.79-2.92L161.15,62l9.27-3.08a.31.31,0,0,0,.21-.23l1.65-9.2,1.66-9.2,1.61-8.92a.32.32,0,0,0,.19-.22A.31.31,0,0,0,175.63,30.89Zm-24.15,33.7-8.26,2.74,1.53-8.51L153,56.07l-.09.48Zm-28-32.84,7.05,5.67L129,45.74l0,.2-7.06-5.67ZM134,19.25l7,5.67-1,.34-7.44,2.47-7-5.66Zm33.22,5.63-8.59,2.85-6.52-5.23-.53-.43,8.59-2.85Zm7.52,6.05-8.58,2.85-6.23-5-.73-.58,8.58-2.85Zm-34.36,4,6.79,5.45-1.52,8.41-6.79-5.46Zm7.34,5-7-5.59,8.48-2.81,7,5.59Zm-1.15,9,1.52-8.4,8.26-2.75-1.51,8.41Zm-6.76-14.48-1.46,8.15-.05.26-7-5.67,1.51-8.4Zm6.64,15.17,8.26-2.75-1.53,8.52-8.26,2.74ZM131.08,37.87l7.06,5.67L136.61,52v.05l-7-5.67ZM138.7,44l6.79,5.45L144,58l-6.79-5.46ZM164,43.79l-1.54,8.52-8.58,2.85,1.53-8.52ZM155.48,46v-.05L157,37.56l8.58-2.86-1.51,8.41Zm10-12-8.59,2.85-7-5.59.32-.11,8.27-2.74,6.32,5.08Zm-7.52-6-.51.17-8.08,2.68L143,25.73l-.73-.58,8.58-2.85Zm-16.33-2.59,6.32,5.09.73.58-8.47,2.82-7-5.67.52-.18Zm-9.42,3-1.43,7.93-.09.48-7-5.67,1.51-8.4Zm39.53,20.9-8.59,2.85,1.53-8.52,8.59-2.85Zm1.65-9.2-8.58,2.85.49-2.73,1-5.67,8.59-2.86ZM159.56,18.76,151,21.61,143.92,16l8.59-2.85Zm-16.32-2.59,7,5.67-.64.21-8,2.64-6.32-5.08-.73-.58ZM121.81,41l7.05,5.67-1.53,8.52-7-5.67Zm7.53,6.6.09-.48,7,5.67L135,61.26l-7.06-5.67ZM137,53.67l.08-.47,6.79,5.45-1.53,8.52-6.79-5.46Zm16.74,2.17L162.29,53v0l-1.52,8.47-8.59,2.85ZM170,58.43l-8.59,2.85L163,52.76l8.58-2.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "128.09 24.73 135.96 31.11 141.26 47.16 121.99 51.66 111.74 43.16 128.09 24.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "77.05 44.81 103.9 28.98 104.98 0 78.13 15.83 77.05 44.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "77.05 44.81 103.9 28.98 104.98 0 78.13 15.83 77.05 44.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "77.08 44.8 101.22 61.04 127.97 45.32 103.83 29.08 77.08 44.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "104.95 0.01 129.09 16.24 127.97 45.32 103.83 29.08 104.95 0.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.76,46.36l-6.48,4.15,1.91,2.9-3.31,2.12L93.43,41.68l3.19-2,20.91,5.88-3.39,2.17Zm-3.59-1.08-7.83-2.36,3.4,5.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M117.52,14.74a3.5,3.5,0,0,1,2.33.78,8,8,0,0,1,2.9,3.61,12.39,12.39,0,0,1,.84,5.4l-.33,8.16-14.67-9.86.31-7.72c.08-1.92.49-3.17,1.21-3.74s1.68-.46,2.85.33a7.49,7.49,0,0,1,1.89,1.84A8.75,8.75,0,0,1,116.1,16,1.84,1.84,0,0,1,117.52,14.74Zm-6.23,6.17,3.46,2.33.15-3.63a5.39,5.39,0,0,0-.36-2.35,3.34,3.34,0,0,0-1.27-1.57c-.57-.39-1-.44-1.31-.17a2.54,2.54,0,0,0-.52,1.76Zm9.38-.3A3.42,3.42,0,0,0,119.34,19q-1.82-1.23-1.94,1.68l-.18,4.26,3.63,2.44.17-4.26A5.86,5.86,0,0,0,120.67,20.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M91.15,13.77a9.85,9.85,0,0,0-3,2.76,15.08,15.08,0,0,0-2.12,4.11,15.34,15.34,0,0,0-.83,4.65,8.2,8.2,0,0,0,.68,3.78,3,3,0,0,0,2,1.72,4.12,4.12,0,0,0,2.92-.65A9.51,9.51,0,0,0,93.36,28a12.7,12.7,0,0,0,1.92-3.19l-1.54-1.25A7.06,7.06,0,0,1,91,26.94a2.35,2.35,0,0,1-1.75.38,1.83,1.83,0,0,1-1.17-1.1,5.4,5.4,0,0,1-.38-2.37A9.34,9.34,0,0,1,88.21,21a8.77,8.77,0,0,1,1.23-2.49,5.7,5.7,0,0,1,1.78-1.67,1.86,1.86,0,0,1,2.63.3L95.47,14a2.49,2.49,0,0,0-1.83-1,4.47,4.47,0,0,0-2.49.72"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIconDemo);
export default __webpack_public_path__ + "static/media/event_icon_demo.6509dff713fad49f6b2d85c0da5d3efc.svg";
export { ForwardRef as ReactComponent };